export default {
  List: {
    Title: "Quản lý giao dịch thanh toán",
    SearchPlaceHolder: "Số đơn hàng",
    Status: "Trạng thái",
    ServiceType: "Loại dịch vụ",
    exportFileName: "Danh sach giao dich",
    SearchInputPlaceholderOtherSchoolType: "Nhập số đơn hàng, mã GD, mã KH, tên KH",
    SearchInputPlaceholderSchoolType: "Nhập mã HS, tên HS, số đơn hàng, mã GD",
    SearchInputPlaceholder: "Tìm kiếm",
  },
  Title: {
    Detail: "Chi tiết giao dịch",
  },
  Button: {
    Agree: "Phê duyệt",
    Decline: "Từ chối",
    Update: "Yêu cầu cập nhật",
    Edit: "Sửa",
    Save: "Lưu",
    Close: "Đóng",
  },
  Detail: {
    SelectPermission: "Chọn quyền",
    Title: "Vai trò quyền hạn",
    AddTitle: "Thêm khách hàng",
    FullName: "Họ và tên",
    EditTitle: "Sửa khách hàng",
    InfoGeneral: "Thông tin chung",
    DuplicateTitle: "Nhân bản vai trò",
    Code: "Mã khách hàng",
    RoleName: "Tên vai trò",
    Email: "Email",
    PhoneNumber: "Số điện thoại",
    RoleCode: "Mã vai trò",
    Gender: "Giới tính",
    Description: "Mô tả",
    All: "Toàn quyền",
    Watch: "Xem",
    Use: "Sử dụng",
    Add: "Thêm",
    Edit: "Sửa",
    Delete: "Xóa",
    Report: "Báo cáo",
    Approve: "Xác nhận",
    Print: "In",
    Import: "Nhập khẩu",
    Export: "Xuất khẩu",
    Transfer: {
      Localtion: "Điều chuyển vị trí tài sản",
      Allocation: "Điều chuyển đối tượng sử dụng",
      OrgUnit: "Điều chuyển đơn vị quản lý",
    },
    Repair: {
      Broken: "Đánh dấu hỏng",
      Repair: "Sửa chữa tài sản",
      Reuse: "Đưa vào sử dụng lại",
      History: "Ghi lịch sử sửa chữa tài sản",
      Schedule: "Lập lịch sửa chữa",
    },
    Maintain: {
      Maintain: "Bảo dưỡng tài sản",
      Reuse: "Đưa vào sử dụng lại",
      History: "Ghi lịch sử bảo dưỡng tài sản",
      Schedule: "Lập lịch bảo dưỡng",
    },
    Inventory: {
      Schedule: "Lập lịch kiểm kê",
    },
    LostCancelLiquidation: {
      Lost: "Đánh dấu mất",
      Cancel: "Đánh dấu huỷ",
      RequestLiquidation: "Đề nghị thanh lý",
      Liquidation: "Thanh lý tài sản",
    },
  },
  SubSystemName: {
    Asset: "Tài sản",
    Increasement: "Ghi tăng",
    Allocation: "Cấp phát",
    Reduce: "Thu hồi",
    Transfer: "Điều chuyển",
    Repair: "Xử lý tài sản hỏng",
    Maintain: "Bảo dưỡng tài sản",
    Inventory: "Kiểm kê",
    LostCancelLiquidation: "Xử lý mất, hủy, thanh lý",
    Dashboard: "Tổng quan",
    R1: "Báo cáo 1",
    r2: "Báo cáo 2",
    AssetType: "Loại tài sản",
    AssetGroup: "Nhóm tài sản",
    OrganizationUnit: "Cơ cấu tổ chức",
    JobLocation: "Vị trí công việc",
    AssetLocation: "Vị trí tài sản",
    Employee: "Nhân viên",
    AssetNorm: "Định mức cấp phát",
    Provider: "Nhà cung cấp",
    User: "Quản lý người dùng",
    AuditingLog: "Nhật ký truy cập",
    Connect: "Kết nối",
    DBOption: "Tùy chọn",
  },
  groupName: {
    GeneralInfo: "Thông tin chung",
    Business: "Phân quyền nghiệp vụ",
    Report: "Phân quyền báo cáo",
    Dictionary: "Phân quyền danh mục",
    System: "Phân quyền hệ thống",
    Dashboard: "Phân quyền tổng quan",
    UserList: "Danh sách người dùng",
  },
  grdDetailUser: {
    UserName: "Tên đăng nhập",
    EmployeeCode: "Mã nhân viên",
    FullName: "Họ và tên",
    OrganizationUnitName: "Đơn vị công tác",
    Email: "Email",
  },
  SelectEmployeeForm: {
    Title: "Chọn người dùng",
    EmployeeCode: "Mã nhân viên",
    FullName: "Họ và tên",
    OrganizationUnitName: "Đơn vị công tác",
    validateNotSelectEmployee: "Bạn chưa chọn nhân viên. Vui lòng kiểm tra lại!",
  },

  Validate: {
    Type_ZERO: "Phân quyền vai trò bị trùng. Vui lòng kiểm tra lại.",
    Type_One:
      "Mỗi người dùng chỉ được phân quyền 1 vai trò trên 1 đơn vị quản lý với 1 nhóm tài sản.",
    Type_NotEmpty: "Vui lòng chọn ít nhất 1 quyền cho vai trò ###0###",
    ConfirmEditChange:
      "Vai trò ###0### đã phát sinh ###1### người dùng. Bạn có chắc chắn muốn thay đổi vai trò này?",
    SelectWatchAsset:
      "Vai trò phải có ít nhất quyền Xem tài sản mới được phân quyền nghiệp vụ khác.",
  },

  Permission: "Thông tin quyền hạn",
  User: "Người dùng",
  Permis: "Quyền hạn",
  HasPermissionData: "Được quyền truy cập dữ liệu",
  ExitHasChange: "Bạn có chắc chắn muốn hủy bỏ?",
  PopupPermission: {
    Title: "Phân quyền",
  },
};
